import React, { useEffect, useState } from 'react';
import Microlink from '@microlink/react';

const isFullURL = (url) => {
  // This ensures TLD is present, like .com, .in, etc.
  const fullUrlPattern = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
  return fullUrlPattern.test(url);
};

const MessageWithLink = ({ message }) => {
  const [link, setLink] = useState(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (!message) {
        setLink(null);
        return;
      }

      const urlPattern = /(https?:\/\/[^\s]+)/gi;
      const urlMatch = message.match(urlPattern);

      if (urlMatch && isFullURL(urlMatch[0])) {
        setLink(urlMatch[0]);
      } else {
        setLink(null);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [message]);

  return (
    <>
      {link && (
        <Microlink url={link} />
      )}
    </>
  );
};

export default MessageWithLink;
